import router from '@/router';
import watermark from '@/directives/watermark';

const cacheKey = 'user';

export function getToken() {
  const cacheStr = localStorage.getItem(cacheKey);
  const cache = JSON.parse(cacheStr || '{}');
  return cache.token;
}

export function getUserInfo() {
  const cacheStr = localStorage.getItem(cacheKey);
  const { userInfo, token } = JSON.parse(cacheStr || '{}');
  watermark.setTextName(userInfo && userInfo.user && userInfo.user.userName);
  return { ...userInfo, token };
}

export function setUserInfo(token, userInfo) {
  localStorage.setItem(cacheKey, JSON.stringify({
    token,
    userInfo
  }));
}

export function logout() {
  localStorage.removeItem(cacheKey);
  router.push('/login');
}



// WEBPACK FOOTER //
// ./src/utils/auth.js